<template lang="pug">
include common.pug
form.card(@submit.prevent="saveBiobank")
    +card-header
    .card-body
        .form-row
            .col: +input("name", {help: "≤ 60 characters"})(required)
            .col: +input("acronym", {help: "≤ 20 characters"})
        +textarea("description", {help: "Description of the biobank in English"})(required)
        //-+input("bioresource_reference", {help: "Reference to be cited when the biobank is used for research", large: true})(maxlength=255)
        +input("url", {label: "Website URL", large: true})(type="url")
        +input("juridical_person", {help: "Name of the legal entity of the biobank", large: true})
        +input("country", {help: "The country in which the biobank resides"})#country(disabled, required)
        //-.card-body
        //-h5 IT-Support
        //-+checkbox("it_support_available", "Biobank has dedicated IT support")
        //-+input("it_staff_size", {
        //-   label: "IT Staff Size",
        //-    if: "value.it_support_available || value.it_staff_size",
        //-   help: "Size of the IT staff of the biobank"
        //-})(type="number", min=0)
        //-+checkbox("is_available", "Internal information management system for tracking biobank processes")
        //-+checkbox("his_available", "Connection to a hospital information system (HIS)")
        //-+checkbox("partner_charter_signed", "BBMRI-ERIC partner charter signed")
    .card-body
        h5 Contact information
        .form-inline.mb-2
            label Biobank Head
                //-+required
            person-select.mx-3(
                v-model="value.head",
                :biobank="value.id",
                status-key="biobank-people",
                @people-status="onPeopleStatus"
            )
            small Natural person in charge of the biobank
            small.text-warning.ml-3(v-if="peopleMissingForBiobank") No people available for this biobank. Create people first.
            //-        .form-inline.mb-2
            //-            +input2("roleNew", {label: "Head Role", help: "typically, principal investigator or director"})
        .form-inline.mb-2
            label Primary External Contact
            person-select.mx-3(v-model="value.contact", :biobank="value.id")
            small.text-warning.ml-2(v-if="peopleMissingForBiobank") No people available for this biobank. Create people first.
        .form-inline.mb-2
            +input("location", { label: "City", help: "The city where the biobank resides"})
        //-.form-inline.mb-2
            label Primary Site Location
            +latLong
        .form-inline.mb-2
            label Networks
            NetworksSelect.mx-3(v-model="value.network" style="min-width: 14rem; flex: 1 1 14rem;")
        .form-group.mt-3
            h6 Capabilities
            MultipleSelect(:labels="BiobankCapabilities", v-model="value.capabilities")
            small List of the capabilities that the biobank can offer to a researcher as a service
        +checkbox("collaboration_commercial", "Biobank is able to participate in commercial collaborations")
        +checkbox("collaboration_non_for_profit", "Biobank is able to participate in collaborations with not-for-profit organisations")
    .card-body
        h5 Alternative Access
        AlsoKnownTable(:alsoKnowns="alsoknown", :parent_type="'biobank'", :parent_id="value.id")
    .page-action-footer
        .container.page-action-footer-inner.biobank-footer-line
            button.btn.btn-primary(type="submit", :disabled="!dirty") Save changes
            span.text-danger.mx-sm-3(v-if="saveErr") {{saveErr.message}}
            span.text-success.mx-sm-3(v-if="saveSuccess") Changes have been saved!
            button.btn.btn-success.ml-3(
                type="button",
                v-if="!value.published",
                :disabled="!canPublish",
                title="Unpublished biobanks do not have their data exported to the BBMRI-ERIC Directory and may have unfilled mandatory properties such as biobank head or description.",
                @click="publishBiobank"
            ) Publish
            small.text-muted.ml-2(v-if="!value.published && missingPublishFields.length > 0")
                | Missing for publish: {{missingPublishFields.join(", ")}}
</template>

<script>
import PersonSelect from "./PersonSelect.vue";
import NetworksSelect from "./NetworksSelect.vue";
import MultipleSelect from "./MultipleSelect.vue";
import BiobankCapabilities from "../labels/BiobankCapabilities.json";
import {getAlsoKnownByBiobank, getAlsoKnownByCollection, getPerson, patchBiobank, patchPerson} from "../api";
import AlsoKnownTable from "./AlsoKnownTable";

export default {
  components: {AlsoKnownTable, PersonSelect, NetworksSelect, MultipleSelect},
  data(){
    return {
      saveSuccess: false,
      saveErr: null,
      dirty: false,
      peopleMissingForBiobank: false,
      alsoknown: [],
      BiobankCapabilities,
    }
  },
  props: {
    value: {type: Object, required: true},
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.saveSuccess = false;
        this.dirty = true;
      }
    }
  },
  methods: {
    // roleChanged() {
    //   return this.roleNew !== this.roleNewOrig;
    // },
    saveBiobank(){
      patchBiobank(this.value)
          .then(() => {
            this.saveSuccess = true;
            this.saveErr = null;
            this.dirty = false;
            // getPerson(this.value.head).then((p) => {
            //   p.role = this.roleNew;
            //   patchPerson(p).then(() => {
            //     this.saveSuccess = true;
            //     this.saveErr = null;
            //     this.dirty = false;
            //     this.roleNewOrig = this.roleNew;
            //   });
            // })
          })
          .catch(err => {
            this.saveSuccess = false;
            this.saveErr = err;
          })
    },
    onPeopleStatus(payload) {
      if (!payload || payload.key !== "biobank-people") return;
      this.peopleMissingForBiobank = !!payload.empty;
    }
    ,
    publishBiobank() {
      this.value.published = true;
      this.saveBiobank();
    }
  },
  computed: {
    missingPublishFields() {
      const missing = [];
      const contactPrefix = (this.value.id || "").replace(/^bbmri-eric:ID:/, "bbmri-eric:contactID:") + "_";
      const hasValidHead = !!(this.value.head && `${this.value.head}`.trim() && `${this.value.head}`.startsWith(contactPrefix));
      const hasValidContact = !!(this.value.contact && `${this.value.contact}`.trim() && `${this.value.contact}`.startsWith(contactPrefix));
      const isPlaceholderContact = this.value.contact && /_0000$/.test(String(this.value.contact));
      if (!this.value.name || !this.value.name.trim()) missing.push("name");
      if (!this.value.description || !this.value.description.trim()) missing.push("description");
      if (!this.value.country || !this.value.country.trim()) missing.push("country");
      if (!this.value.juridical_person || !this.value.juridical_person.trim()) missing.push("juridical_person");
      if (!hasValidHead) missing.push("head");
      if (!hasValidContact || isPlaceholderContact) missing.push("contact");
      return missing;
    },
    canPublish() {
      return this.missingPublishFields.length === 0;
    }
  },
  created() {
    getAlsoKnownByBiobank(this.value.id)
        .then(alsoKnownList => this.alsoknown = alsoKnownList)
  }

}
</script>

<style scoped>
#country { width: 4em; }

.biobank-footer-line {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.25rem;
}

.biobank-footer-line .btn {
    white-space: nowrap;
}
</style>
